import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';

import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';

import styles from './styles.css';

interface IListItem {
  handleClick: () => void;
  icon: React.ReactNode;
  title: string;
}
export const ListItem: React.FC<IListItem> = ({ title, handleClick, icon }) => {
  return (
    <div className={styles['list-item']} onClick={handleClick}>
      <div className={styles['item-info']}>
        {icon}
        <UIHeading4>{title}</UIHeading4>
      </div>
      <IconActionChevronRight12 color="icon-main-default" />
    </div>
  );
};
